var nav = document.querySelector('nav');

window.addEventListener('scroll', function() {
    $('.navbar-collapse').removeClass('show')
    $('.navbar-collapse').addClass('collapsed');
    if (window.scrollY > 200) {
        nav.classList.add('bg-blue-header', 'shadow');
    } else {
        nav.classList.remove('bg-blue-header', 'shadow');
    }
});